export const actionTypes = {
  UNLOCK_KIOSK_MODE: 'UNLOCK_KIOSK_MODE',
  UNLOCK_KIOSK_MODE_LOADING: 'UNLOCK_KIOSK_MODE_LOADING',
  UNLOCK_KIOSK_MODE_ERROR: 'UNLOCK_KIOSK_MODE_ERROR',
  RESET_UNLOCK_KIOSK_MODE_RESULT: 'RESET_UNLOCK_KIOSK_MODE_RESULT',
};
